const ID_SITUACAO_AUTO_CADASTRO_USUARIO_RASCUNHO = 1;
const SITUACAO_AUTO_CADASTRO_USUARIO_RASCUNHO= {
	id: ID_SITUACAO_AUTO_CADASTRO_USUARIO_RASCUNHO,
	nome: 'Rascunho'
}

const ID_SITUACAO_AUTO_CADASTRO_USUARIO_AGUARDANDO_ASSINATURA = 2;
const SITUACAO_AUTO_CADASTRO_USUARIO_AGUARDANDO_ASSINATURA= {
	id: ID_SITUACAO_AUTO_CADASTRO_USUARIO_AGUARDANDO_ASSINATURA,
	nome: 'Aguardando assinatura'
}

const ID_SITUACAO_AUTO_CADASTRO_USUARIO_EM_ANALISE = 3;
const SITUACAO_AUTO_CADASTRO_USUARIO_EM_ANALISE= {
	id: ID_SITUACAO_AUTO_CADASTRO_USUARIO_EM_ANALISE,
	nome: 'Em análise'
}

const ID_SITUACAO_AUTO_CADASTRO_USUARIO_APROVADA = 4;
const SITUACAO_AUTO_CADASTRO_USUARIO_APROVADA = {
	id: ID_SITUACAO_AUTO_CADASTRO_USUARIO_APROVADA,
	nome: 'Deferida'
}

const ID_SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA = 5;
const SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA = {
	id: ID_SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA,
	nome: 'Rejeitada'
}



export {
	ID_SITUACAO_AUTO_CADASTRO_USUARIO_EM_ANALISE, SITUACAO_AUTO_CADASTRO_USUARIO_EM_ANALISE,
	ID_SITUACAO_AUTO_CADASTRO_USUARIO_APROVADA, SITUACAO_AUTO_CADASTRO_USUARIO_APROVADA,
	ID_SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA, SITUACAO_AUTO_CADASTRO_USUARIO_REPROVADA,
	ID_SITUACAO_AUTO_CADASTRO_USUARIO_RASCUNHO, SITUACAO_AUTO_CADASTRO_USUARIO_RASCUNHO,
	ID_SITUACAO_AUTO_CADASTRO_USUARIO_AGUARDANDO_ASSINATURA, SITUACAO_AUTO_CADASTRO_USUARIO_AGUARDANDO_ASSINATURA
 }